import { Action } from '@ngrx/store';
import { ShippingConditionsRequest } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-conditions-request';
import { ShippingConditionsResponse } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-conditions-response';
import { ShippingCondition } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-condition';

export const LOAD_INITIAL_STATE = '[Shipping condition] Load initial state';
export const LOAD = '[Shipping condition] Load';
export const LOAD_COMPLETE = '[Shipping condition] Load Complete';
export const LOAD_FAIL = '[Shipping condition] Load Fail';
export const SET = '[Shipping condition] SET Shipping condition';

/* If we have information about business line we can set it directly */
export const SET_DIRECT = '[Shipping condition] SET_DIRECT Shipping condition';
export const RESET = '[Shipping condition] RESET Shipping condition';

export class ShippingConditionLoadInitialStateAction implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor(public payload = null) {}
}

export class ShippingConditionLoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: ShippingConditionsRequest) {}
}

export class ShippingConditionLoadCompleteAction implements Action {
  readonly type = LOAD_COMPLETE;

  constructor(public payload: ShippingConditionsResponse) {}
}

export class ShippingConditionFailAction implements Action {
  readonly type = LOAD_FAIL;

  constructor(public payload: any) {}
}

export class ShippingConditionSetAction implements Action {
  readonly type = SET;

  constructor(public payload: number) {}
}

export class ShippingConditionSetDirectAction implements Action {
  readonly type = SET_DIRECT;

  constructor(public payload: ShippingCondition) {}
}

export class ShippingConditionResetAction implements Action {
  readonly type = RESET;

  constructor(public payload: null = null) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type ShippingConditionsActions =
  | ShippingConditionLoadInitialStateAction
  | ShippingConditionLoadAction
  | ShippingConditionLoadCompleteAction
  | ShippingConditionFailAction
  | ShippingConditionSetAction
  | ShippingConditionResetAction
  | ShippingConditionSetDirectAction;
